import React from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/images/looms.jpg"
          alt="Veltrix Apparel"
          className="w-full h-full object-cover scale-105"
        />
        <div className="absolute inset-0 bg-slate-900/70" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/50" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-white/90 text-sm font-medium uppercase tracking-widest mb-4 animate-fade-in drop-shadow-[0_1px_2px_rgba(0,0,0,0.8)]">
          Manhattan, NY
        </p>
        <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold text-white tracking-tight max-w-4xl mx-auto animate-fade-in drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]">
          Suits. Jerseys. Kits.
        </h1>
        <p className="mt-6 text-lg md:text-xl text-white max-w-2xl mx-auto leading-relaxed animate-slide-up drop-shadow-[0_1px_4px_rgba(0,0,0,0.5)]">
          Tailored formal wear, football jerseys, and performance kits. One destination for the modern man.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center animate-slide-up">
          <Link
            to="/collections"
            className="inline-flex items-center justify-center px-8 py-3.5 rounded-lg bg-white text-slate-900 font-medium text-sm hover:bg-slate-100 transition-colors"
          >
            Explore Collections
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center justify-center px-8 py-3.5 rounded-lg border border-white/50 text-white font-medium text-sm hover:bg-white/10 transition-colors drop-shadow-[0_1px_3px_rgba(0,0,0,0.4)]"
          >
            Our Story
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 drop-shadow-[0_1px_4px_rgba(0,0,0,0.5)]">
        <div className="w-6 h-10 rounded-full border-2 border-white/50 flex items-start justify-center p-2">
          <div className="w-1 h-2 rounded-full bg-white animate-bounce" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
